export default function ShowSVG({ svg, style }) {
  return (
    <div className="flex-row-center" style={{ marginTop: "4px", marginBottom: "0px,  ...style"  }}>
      <div dangerouslySetInnerHTML={{ __html: svg }} />
    </div>
  );
}
